import React from 'react'

export const Muscle = props => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path 
        d="M11.3621 0.536788C11.8462 0.629438 12.5531 0.871048 12.8942 1.55322C13.6412 3.04733 13.0246 4.46721 12.3622 5.3504C11.9302 5.92648 11.3738 6.46854 10.7266 6.80044C10.5914 6.86978 10.316 7.00048 9.99966 7.00047C9.40846 7.00044 8.82956 6.73147 8.35496 6.39566C8.26496 6.70153 8.17826 7.03759 8.10326 7.39389C7.96159 8.06699 7.86871 8.77909 7.86365 9.47169C8.91606 9.13139 9.99256 9.16749 10.9212 9.69189C11.5556 9.18499 12.3794 8.75349 13.2774 8.51809C14.5787 8.17699 16.1383 8.22419 17.5544 9.16829C18.5702 9.84539 19.3388 11.1209 19.4937 12.515C19.6553 13.9692 19.151 15.56 17.6245 16.7812C16.5462 17.6439 14.9023 17.9764 13.3903 18.0977C11.8255 18.2232 10.1726 18.1369 8.88926 17.9943C6.51177 17.7302 4.68626 17.0666 3.41039 16.3814C2.57257 15.9314 1.42812 15.31 1.0651 14.3561C0.819388 13.7105 0.883538 12.9273 0.943788 12.2549C1.02281 11.373 1.21944 10.2731 1.58632 9.08119C2.31841 6.70292 3.7513 3.88781 6.36264 1.72957C7.16612 1.06551 8.51006 0.653758 9.63456 0.515698C10.2152 0.444408 10.8256 0.434098 11.3621 0.536788Z"
    />
  </svg>
)
